import React, { useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { 
  FaBrain, 
  FaBone, 
  FaRunning, 
  FaUserInjured, 
  FaHandsHelping, 
  FaHeartbeat, 
  FaChild, 
  FaHands, 
  FaBolt, 
  FaDumbbell 
} from 'react-icons/fa';

const Services = ({ t }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      const elements = sectionRef.current.querySelectorAll('.fade-in, .scroll-fade-up, .scroll-fade-left, .scroll-fade-right, .scroll-zoom, .scroll-rotate');
      elements.forEach(el => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      icon: <FaBrain />,
      title: t.services.list.adhd.name,
      description: t.services.list.adhd.desc,
      delay: '0.1s'
    },
    {
      icon: <FaBone />,
      title: t.services.list.orthopedic.name,
      description: t.services.list.orthopedic.desc,
      delay: '0.2s'
    },
    {
      icon: <FaRunning />,
      title: t.services.list.sports.name,
      description: t.services.list.sports.desc,
      delay: '0.3s'
    },
    {
      icon: <FaUserInjured />,
      title: t.services.list.postSurgery.name,
      description: t.services.list.postSurgery.desc,
      delay: '0.4s'
    },
    {
      icon: <FaHandsHelping />,
      title: t.services.list.geriatric.name,
      description: t.services.list.geriatric.desc,
      delay: '0.5s'
    },
    {
      icon: <FaHeartbeat />,
      title: t.services.list.neuro.name,
      description: t.services.list.neuro.desc,
      delay: '0.6s'
    },
    {
      icon: <FaChild />,
      title: t.services.list.pediatric.name,
      description: t.services.list.pediatric.desc,
      delay: '0.7s'
    },
    {
      icon: <FaHands />,
      title: t.services.list.manual.name,
      description: t.services.list.manual.desc,
      delay: '0.8s'
    },
    {
      icon: <FaBolt />,
      title: t.services.list.electro.name,
      description: t.services.list.electro.desc,
      delay: '0.9s'
    },
    {
      icon: <FaDumbbell />,
      title: t.services.list.exercise.name,
      description: t.services.list.exercise.desc,
      delay: '1.0s'
    }
  ];

  return (
    <section id="services" className="section-padding" ref={sectionRef}>
      <Container>
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8}>
            <h2 className="section-title scroll-fade-up title-enhance">{t.services.title}</h2>
            <p className="section-subtitle scroll-fade-up fade-in-delay-1">{t.services.subtitle}</p>
          </Col>
        </Row>

        <Row className="stagger-animation">
          {services.map((service, index) => (
            <Col lg={4} md={6} key={index} className="mb-4">
              <div 
                className="service-card scroll-zoom hover-lift hover-glow animate-shimmer" 
                style={{ 
                  '--i': index,
                  animationDelay: service.delay 
                }}
              >
                <div className="service-icon animate-heartbeat hover-rotate">
                  {service.icon}
                </div>
                <h4 className="service-title">{service.title}</h4>
                <p className="service-description scroll-fade-left">{service.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Services;